import React from 'react';
import { BootstrapTooltip } from '../../../assets/js/script';


const TablesRow = ({ rowData, columns, hideIcons, onEdit, onDelete, onView, onAccessChange, showIcons, onClone, pageLevelAccessData }) => {
    const handleCheckboxChange = (field) => {
        const newValue = !rowData[field];
        onAccessChange({ ...rowData, field, value: newValue });
    };

    const formatTextWithLineBreaks = (text) => {
        if (typeof text !== 'string') return text;
        const words = text.split(' ');
        return words.map((word, index) => ((index + 1) % 10 === 0 ? word + '<br/>' : word)).join(' ');
    };

    return (
        <tr className="manage-page-group xcruit-table__row">
            {columns.map((column) => (
                <td key={column}>
                    {column === 'icon' ? (
                        <span dangerouslySetInnerHTML={{ __html: rowData.icon }} />
                    ) : (
                        typeof rowData[column] === 'string' ? (
                            <span
                                dangerouslySetInnerHTML={{ __html: formatTextWithLineBreaks(rowData[column]) }}
                            />
                        ) : (
                            rowData[column]
                        )
                    )}
                </td>
            ))}

            {hideIcons && (
                <>
                    <td>
                        <div className="form-check form-switch form-switch-custom form-switch-primary">
                            <input
                                className="form-check-input"
                                type="checkbox"
                                role="switch"
                                id={`viewAccess-${rowData.id}`}
                                checked={rowData.viewAccess}
                                onChange={() => handleCheckboxChange('viewAccess')}
                            />
                        </div>
                    </td>
                    <td>
                        <div className="form-check form-switch form-switch-custom form-switch-primary">

                            <input
                                className="form-check-input"
                                type="checkbox"
                                role="switch"
                                id={`addAccess-${rowData.id}`}
                                checked={rowData.addAccess}
                                onChange={() => handleCheckboxChange('addAccess')}
                            />
                        </div>
                    </td>
                    <td>
                        <div className="form-check form-switch form-switch-custom form-switch-primary">
                            <input
                                className="form-check-input"
                                type="checkbox"
                                role="switch"
                                id={`editAccess-${rowData.id}`}
                                checked={rowData.editAccess}
                                onChange={() => handleCheckboxChange('editAccess')}
                            />

                        </div>
                    </td>
                    <td>
                        <div className="form-check form-switch form-switch-custom form-switch-primary">
                            <input
                                className="form-check-input"
                                type="checkbox"
                                role="switch"
                                id={`deleteAccess-${rowData.id}`}
                                checked={rowData.deleteAccess}
                                onChange={() => handleCheckboxChange('deleteAccess')}
                            />
                        </div>
                    </td>
                    <td>
                        <div className="form-check form-switch form-switch-custom form-switch-primary">
                            <input
                                className="form-check-input"
                                type="checkbox"
                                role="switch"
                                id={`downloadAccess-${rowData.id}`}
                                checked={rowData.downloadAccess}
                                onChange={() => handleCheckboxChange('downloadAccess')}
                            />
                        </div>
                    </td>
                </>
            )}

            {!hideIcons && (
                <td>
                    <div className="xc-table-actions">
                    {showIcons && (
                        <BootstrapTooltip title="Clone">
                            {pageLevelAccessData.addAccess ? (
                                <span className="cursor-pointer xc-action-icon" data-toggle="tooltip" onClick={() => onClone(rowData.id)}>
                                    <i className="ri-file-copy-line"></i>
                                </span>
                            ) : ''}
                        </BootstrapTooltip>
                    )}
                    {onView ? (
                        <BootstrapTooltip title="View">
                            <span className="cursor-pointer xc-action-icon xc-action-icon--view" onClick={onView} data-toggle="tooltip">
                                <i className="ri-eye-line"></i>
                            </span>
                        </BootstrapTooltip>
                    ) : ''}
                    <BootstrapTooltip title="Edit">
                        {pageLevelAccessData.editAccess ? (
                            <span className="cursor-pointer xc-action-icon xc-action-icon--edit" onClick={onEdit} data-toggle="tooltip">
                                <i className="ri-pencil-line"></i>
                            </span>
                        ) : ''}
                    </BootstrapTooltip>
                    <BootstrapTooltip title="Delete">
                        {pageLevelAccessData.deleteAccess ? (
                            <span className="cursor-pointer xc-action-icon xc-action-icon--danger" onClick={onDelete} data-toggle="tooltip">
                                <i className="ri-delete-bin-6-line"></i>
                            </span>
                        ) : ''}
                    </BootstrapTooltip>
                    {!pageLevelAccessData.editAccess && !pageLevelAccessData.deleteAccess ?
                        (pageLevelAccessData.addAccess ? '' : (
                            <span className="xc-table-actions__forbidden">
                                Forbidden
                            </span>
                        )) : ''
                    }
                    </div>
                </td>
            )}
        </tr>
    );
};

export default TablesRow;
